import React, { useState, useEffect } from 'react';
import { conversationState } from "../../store/atoms";
import './Home.css';
import CurrentCoversation from './CurrentConversation';
import { Amplify } from 'aws-amplify';
import { useRecoilValue, useRecoilState } from 'recoil';
import TargetedSearch from './TargetedSearch';
import Sidebar_v2 from '../sidebar/Sidebar_v2';
import PromptBar from "./PromptBar";
import { logEvent } from '../../cloudwatchLogger';  // Import the logEvent function
import useLambda from '../hooks/useLambda';
import { awsExports } from '../../aws-exports';
import AWS from 'aws-sdk';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import {conversationIdState} from '../../store/atoms'
import WelcomeHeader from './WelcomeHeader';

Amplify.configure(awsExports);


const TargetPage = () => {
  const conversation = useRecoilValue(conversationState);
  const [selectedQuery, setSelectedQuery] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const isMobile = useMediaQuery('(max-width:768px)');
  

  useEffect(() => {
    const storedQuery = localStorage.getItem('selectedQuery');
    if (storedQuery) {
      setSelectedQuery(storedQuery);
      localStorage.removeItem('selectedQuery');
      logEvent({ eventType: 'storedQueryLoaded', details: `Loaded stored query: ${storedQuery}` });
    }
    
    // Add event listener for popstate
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
      //logEvent({ eventType: 'componentUnmounted', details: 'TargetPage component unmounted' });
    };
  }, []);

  const handlePopState = () => {
    if (conversation.length > 0) {
      // If there's a conversation, clear it and show TargetedSearch
      // You might need to implement a function to clear the conversation state
      // clearConversation();
      navigate('/targetPage', { replace: true });
    }
  };

  useEffect(() => {
    if (location.state?.from === 'search' && conversation.length === 0) {
      navigate('/targetPage', { replace: true });
    }
  }, [location, conversation, navigate]);


  useEffect(() => {
    //logEvent({ eventType: 'conversationStateChanged', details: `Conversation length: ${conversation.length}` });
  }, [conversation]);

  const handleQuerySelect = (query) => {
    setSelectedQuery(query);
    logEvent({ eventType: 'querySelected', details: `Selected query: ${query}` });
  };

  const themeStyles = {
    backgroundColor: '#FFF',
    color: '#000',
    minHeight: '100vh',
    display: "flex",
    width: "100%"
  };

  const toggleSidebar = () => {
    logEvent({ action: 'SidebarToggled', message: `Sidebar ${isSidebarCollapsed ? 'expanded' : 'collapsed'}` });
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className={`bg-white text-black ${isMobile ? 'fixed' : 'h-screen'} flex w-full overflow-hidden`}>
      <div className='max-w-full w-full overflow-y-auto'>
        <WelcomeHeader />
        <main className={`${isMobile ? 'p-5' : 'pt-[3.75rem] pb-[3.75rem]'} flex flex-col items-center flex-1 gap-[3.75rem] w-fulld`}>
          <div className="flex w-[51rem] flex-col items-center gap-[1.625rem]">
            {!isMobile && (
              <div className="flex w-[22.625rem] h-[2.9375rem] justify-center items-center">
                <img
                  src="/findraiser_title6.svg"
                  alt="Better Targets, Now"
                  className="h-[39px]"
                />
              </div>
            )}
            <PromptBar
              selectedQuery={selectedQuery}
              onQuerySubmit={(query) => {
                logEvent({ eventType: 'querySubmitted', details: `Submitted query: ${query}` });
              }}
            />
          </div>
          {/* use this div we needed in center like earlier for response table <div className={` ${isMobile ? 'h-[90vh]' : ''}`}> */}
          <div className={`${conversation.length !== 0 ? 'w-full' : ''} ${isMobile ? 'h-[90vh]' : ''}`}>
            {conversation.length === 0 ? (
              <TargetedSearch
                selectedQuery={selectedQuery}
                setSelectedQuery={handleQuerySelect}
              />
            ) : (
              <>
              {/* change the width of the conversation box by increasing the px value */}
                <div className="flex h-[35.75rem] flex-col items-start self-stretch px-12">
                  <CurrentCoversation />
                </div>
              </>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default TargetPage;